module.exports = __webpack_public_path__ + "e06af8a34046f1199bf9d3d0e9512715.png";